import ListingResource from './listing-resource';
import { observable, action } from 'mobx';
import Cons from '../../isomorphic/cons';
import Notifications from '../utils/notification-helper';
import GooglePlacesHelper from '../utils/google-places-helper';
import moment from 'moment';

export default class ListingStore {
    @observable isLoading = false;

    constructor(appStore) {
        this.appStore = appStore;
        this.listingResource = new ListingResource();
    }

    @action
    getListingsById(listingId) {
        return this.listingResource.getById(this.appStore.authStore.getAccessToken(), listingId);
    }

    @action
    createNewListing(listingFields) {
        const newListing = this.listingFromFields(listingFields);
        this.isLoading = true;
        this.listingResource
            .createNewListing(this.appStore.authStore.getAccessToken(), newListing)
            .then(result => {
                const listingId = result.listing.Id;
                return this.appStore.tcFileStore.createFileFromListing(listingId, {
                    typeOfSale: listingFields.typeOfSale ? listingFields.typeOfSale : null,
                    status: Cons.fileStatuses['Incomplete'],
                    origin: 'Listing',
                    fileSubmissionDate: moment(new Date()),
                    estimatedCloseDate: null,
                });
            })
            .then(() => {
                this.appStore.viewStore.openFileDetailPageForNew({ tcFileId: 'new' });
                this.isLoading = false;
            })
            .catch(err => {
                let errorMessage = 'Error creating new listing.';
                switch (err.response.statusCode) {
                    case 409:
                        errorMessage += ' An existing listing with the same address exists.'; 
                        break;
                    case 400:
                        errorMessage += ` validating Prime API: ${err.response.body.error.message}`
                        break;
                    default:
                        errorMessage += ` Error Prime API  ${err.message}`;
                  }
                  
                Notifications.ToastError(errorMessage);
                console.log(err);
                this.isLoading = false;
            });
    }

    listingFromFields(listingFields) {
        const newListing = {
            StreetNumber: listingFields.address1,
            Direction: listingFields.direction,
            StreetName: listingFields.address2,
            City: listingFields.city,
            State: listingFields.state,
            County: listingFields.county,
            Zip: listingFields.zip,
            ListingAgentId: listingFields.agent[0] ? listingFields.agent[0].agentContactId : undefined,
            SubscriberId: listingFields.agent[0] ? listingFields.agent[0].subscriberId : undefined,
            ListingDate: listingFields.listingDate,
            PropertyTypeId: listingFields.propertyType,
            OfficeId: listingFields.office,
            Unit: listingFields.unitNum,
        };

        return newListing;
    }

    convertSelectedFile() {
        this.isLoading = true;
        const selectedFile = this.appStore.tcFileStore.selectedFile;

        if (!selectedFile.isNew && selectedFile.origin === 'Listing') {
            const conversionData = {
                listingId: selectedFile.originId,
                subscriberId: selectedFile.subscriberId,
                agentContactId: selectedFile.agents[0].agentContactId,
            };

            return this.listingResource
                .convertListing(this.appStore.authStore.getAccessToken(), conversionData)
                .then(result => {
                    this.isLoading = false;

                    return result;
                })
                .catch(err => {
                    this.isLoading = false;

                    return err;
                });
        }
    }
}



// WEBPACK FOOTER //
// ./src/listings/listing-store.js